// @flow
import type { Node } from 'react';
import { connect } from 'react-redux';
import type { State, TargetType } from '../../../types';
import { TYPE } from '../../../constants/targetConstants';
import { makeCarEntityAutoSelector } from '../../../selectors/carSelectors';
import { makePlaneEntitySelector } from '../../../selectors/planeSelectors';

type OwnProps = $ReadOnly<{|
    type: TargetType,
    icao: string
|}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    let target;
    if(props.type === TYPE.car) {
        const targetBuffer = makeCarEntityAutoSelector(props.icao)(state);
        target = targetBuffer && targetBuffer[0];
    }
    else if(props.type === TYPE.plane) {
        const targetBuffer = makePlaneEntitySelector(props.icao)(state);
        target = targetBuffer && targetBuffer[0];

        if (!target) {
            throw new Error(`Entity for target ${props.icao} of type ${props.type} not found`);
        }
    }
    else {
        throw new Error(`Unknown type ${props.type}`);
    }

    return {
        target
    };
};

type Props = $ReadOnly<{
    target?: TargetType,
    children: (target?: TargetType) => Node
}>;
const TargetFeeder = ({ target, children }) => children(target);


export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(TargetFeeder);